import * as React from 'react';
import PageMobileWrapper from '~/common/elements/mobile/PageMobileWrapper';
import SaleHeader from '~/apps/pos/mobile/components/sales/SaleHeader';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';
import Button from '~/common/elements/mobile/Button';
import { buttonSize, buttonStyle } from '~/common/elements/mobile/consts';

type Props = {
  onBack: any,
  backActionKey: any,
  menuActions: any,
}
const HistoryMenu = (props: Props) => {
  const { backActionKey, menuActions, onBack } = props;

  const handleActions = (actionKey, e) => {
    if (e) e.preventDefault();

    switch (actionKey) {
      case 'on-click-left':
        if (onBack) onBack(backActionKey);
        break;

      case 'logout':
        if (menuActions) menuActions('logout');
        break;

      default:
        console.log(`Action key: ${actionKey}`)
    }
    return name;
  };

  return (
    <PageMobileWrapper>
      <SaleHeader
        onBack={handleActions}
        title=""
      />

      <BodyWrapper>
        <div className="m--login__head">
          <div className="logo--inline">
            <img className="logo--m" src="/assets/img/logo-mark.svg" alt="" />
            <img className="logo--t" src="/assets/img/logo-text.svg" alt="" />
          </div>
          <p className="m--login__titl">Secure and instant payments.<br />Built for logistics.</p>
        </div>

        <div className="m__foot">
          <Button
            title="Logout"
            actionKey="logout"
            buttonStyle={buttonStyle.SECN}
            buttonSize={buttonSize.LG}
            onClick={handleActions}
            customStyle={{width: '100%'}}
          />
        </div>
      </BodyWrapper>
    </PageMobileWrapper>
  );
};

export default HistoryMenu;
